import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RecipientOrderConfigService {
  private configMap = new Map<string, string[]>();

  getConfig(fileKey: string): string[] | undefined {
    return this.configMap.get(fileKey);
  }

  setConfig(fileKey: string, config: string[]): void {
    this.configMap.set(fileKey, [...config]);
  }

  hasConfig(fileKey: string): boolean {
    return this.configMap.has(fileKey);
  }

  clearConfig(fileKey: string): void {
    this.configMap.delete(fileKey);
  }

  clearAll(): void {
    this.configMap.clear();
  }
}